module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#photostory",
      toString: function () {
        return this.url;
      }
    }